// extracted by mini-css-extract-plugin
export default {"wrapper":"search_bar-module__wrapper--2Y5mQ","section":"search_bar-module__section--1oA1A","group":"search_bar-module__group--1UMSv","expanded":"search_bar-module__expanded--2_wU8"};